import { create } from 'zustand';

const useAppStore = create((set) => {
  const savedNotifications = localStorage.getItem('notifications');
  let notifications = [];
  if (savedNotifications) {
    try {
      notifications = JSON.parse(savedNotifications);
    } catch (e) {
      console.debug(e);
    }
  }
  return {
    hero: 'graphics',
    isDrawerOpen: false,
    setIsDrawerOpen: (isOpen) => set(() => ({ isDrawerOpen: isOpen })),
    selectedItem: null,
    setSelectedItem: (item) => set(() => ({ selectedItem: item })),
    navigation: null,
    setNavigation: (nav) => set(() => ({ navigation: nav })),
    startRequestForm: () => set(() => ({ hero: 'form' })),
    completeRequestForm: () => set(() => ({ hero: 'graphics' })),
    notifications,
    addNotification: (notification) => {
      set((current) => {
        const exists = current.notifications.find(
          (n) => n._id === notification._id,
        );
        if (exists) {
          return { notifications: current.notifications };
        }
        const notifications = [...current.notifications, notification];
        localStorage.setItem('notifications', JSON.stringify(notifications));
        return { notifications };
      });
    },
    deleteNotification: (notification) => {
      set((current) => {
        const filtered = current.notifications.filter(
          (n) => n._id !== notification._id,
        );
        localStorage.setItem('notifications', JSON.stringify(filtered));
        return {
          notifications: filtered,
        };
      });
    },

    isSearchOpen: false,
    setIsSearchOpen: (isClicked) => set(() => ({ isSearchOpen: isClicked })),
    dialogForm: null,
    setDialogForm: (form) => set(() => ({ dialogForm: form })),
    settingsOpen: false,
    setSettingsOpen: (isOpen) => set(() => ({ settingsOpen: isOpen })),
    logoFileId: null,
    setLogoFileId: (id) => set(() => ({ logoFileId: id })),
    favIconFileId: null,
    setFavIconFileId: (id) => set(() => ({ favIconFileId: id })),
    styles: null,
    setStyles: (style) => set(() => ({ styles: style })),
    deploymentTitle: null,
    setDeploymentTitle: (title) => set(() => ({ deploymentTitle: title })),
    colorScheme: 'light',
    setColorScheme: (color) => set(() => ({ colorScheme: color })),
    interfaces: null,
    setInterfaces: (ifaces) => set(() => ({ interfaces: ifaces })),
    t2w: null,
    setT2w: (t2w) => set(() => ({ t2w })),
  };
});

export default useAppStore;
